// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"0c77963a","271":"82a312cb"}[chunkId] + ".chunk.css";
};